import React, { useEffect, useState } from 'react'
import HeroHeader from '../components/HeroHeader';
import OverBanner from '../components/OverBanner';
import QuotePopup from '../components/DeferredQuotePopup';
import header from '../public/Pictures/partnerships_head.jpg'
import ob1 from '../public/Pictures/partnership_overbanner.jpg'
import { helper } from '../utilities/helper';
import { AiOutlinePhone } from '@react-icons/all-files/ai/AiOutlinePhone';
import { AiOutlineClockCircle } from '@react-icons/all-files/ai/AiOutlineClockCircle';
import { AiOutlineForm } from '@react-icons/all-files/ai/AiOutlineForm';
import Button from '../components/Button';
import { AiOutlineMail } from '@react-icons/all-files/ai/AiOutlineMail';
import { useDispatch, useSelector } from 'react-redux';
import { CLOSE_POPUP, SHOW_LOGIN, SHOW_POPUP } from '../store/slices/ui';
import * as gtag from '../lib/gtag'
import { NextSeo } from 'next-seo';
import B2BModelOne from '../components/B2BModelOne';
import SignInForm from '../components/SignInForm';
import B2BModelTwo from '../components/B2BModelTwo';
import B2BModelThree from '../components/B2BModelThree';
import B2BModelFour from '../components/B2BModelFour';
import B2BTable from '../components/B2BTable';
import B2BIndex from '../components/B2BIndex';
import { useRouter } from 'next/dist/client/router';
import { getUser } from '../store/slices/user';
import B2BSalesPres from '../components/B2BSalesPres';
import axios from 'axios';
import { SERVER_IP } from '../store/middleware/api';
import ClientReviews from '../components/ClientReviews';
import PastEvents from '../components/PastEvents';
import { wrapper } from '../store/configStore';
import { compactPublicEvents } from '../utilities/eventPublicPayload';
export const getStaticProps = wrapper.getStaticProps(
  async ({ store, preview }) => {

      const corp = await axios.request(`${SERVER_IP}/user/static-corporate`)

      let { employees, newsletterevents, total_events } = corp?.data
      return {
          props: {
              employees, newsletterevents: compactPublicEvents(newsletterevents), total_events
          }
      }
  }
);

const Partnerships = ({ employees, newsletterevents, total_events }) => {
  let dispatch = useDispatch()
  let { user } = useSelector(getUser)
  let [model, setModel] = useState()
  let [form, showForm] = useState(false)
  let { query } = useRouter()

  let { one, two, three, four, id, presentation } = query

  one= true
  two = true
  three = true
  four= true

  let arr = [one, two, three, four]
  let visible = arr.filter(m => m)





  let bHours = helper.isBusinessHour()

  if (id && user?.employee && !query?.sign) return <B2BSalesPres id={id} />


  if (form || id || query.apply) return <SignInForm id={id} />

  return <>
    <NextSeo
      noindex={true}
      nofollow={true}
      title='Partnerships | Miami Sound Rental'
      description='Partner with the fastest growing AV provider in Florida'
      canonical="https://miamisoundrental.com/partnerships"
      twitter={{
        handle: '@miamisoundrent1',
        site: '@miamisoundrent1',
        cardType: 'summary_large_image',
      }}
      openGraph={{
        type: 'website',
        url: `https://miamisoundrental.com/partnerships`,
        title: 'Partnerships | Miami Sound Rental',
        description: 'Partner with the fastest growing AV provider in Florida',
        images: [
          {
            url: 'https://dnw-server.s3.us-east-2.amazonaws.com/corporate_og2.jpg',
            width: 800,
            height: 600,
            alt: 'Miami Sound Rental',
          },

        ],
        site_name: 'Miami Sound Rental',
      }}
    />
    <div className='partnerships'>

      <HeroHeader
        picture={header}
        title={''}

      >
        <p className='titleTop'>Hospitality Partnerships</p>
        <h1 className='upperBold'>Find out why world-class hotels are switching their in-house AV to us</h1>
        <p>We put to work together <strong>technology, data</strong> and <strong>operational & execution excellence</strong> to improve the <strong>Corporate Meeting and Events customer journey</strong>, from RFP response to event and guest experience transformation.</p>

      </HeroHeader>
      <section className='attributes promoVideo'>
        <div className='video-cont'>
          <div className='media-video' >
            <iframe title={'Miami Sound Rental Partnerships'} src={helper.embed('https://youtu.be/uL3F9hk8u1c?si=1rhOxoWRVs3kOClo')} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen></iframe>
          </div>
        </div>
      </section>
      <section className='attributes'>

        <div className="upperBold">What makes us different?</div>
        <div className="row">
          <div className="col">
            <div className="headCard">
              +95% Faster RFP Process
            </div>
            <div className="topP">
              <p>
                Big productions take 36h on average to be quoted, with our platform you can do it in less than 30 minutes.
              </p>
            </div>
            <div
              className="bottomP">
              <p>
                That agility provides our partner a competitive industry advantage in RFP process, from pre-booking to event personalization phase.
              </p>
            </div>
          </div>
          <div className="col inner">
            <div className="headCard">
             4.9 / 5 Rated Service
            </div>
            <div className="topP">
              <p>
                We are proud to be the best rated AV provided in South Florida with 4.9/5 rating and hundreds of reviews.
              </p>
            </div>
            <div
              className="bottomP">
              <p>
                At Miami Sound Rental we understand it is your reputation what is on the line when you partner with a vendor, that is why we only provide the best service to our clients.
              </p>
            </div>
          </div>
          <div className="col inner">
            <div className="headCard">
              Simple & Transparent
            </div>
            <div className="topP">
              <p>
                Say goodbye to obscure estimates that make impossible to understand what you are getting. Our exclusive app simplifies even the most complex of events.
              </p>
            </div>
            <div
              className="bottomP">
              <p>
                Our <strong>Event Builder</strong> let you and your clients work on the event and modify every aspect of it dynamically, with full price transparency.
              </p>
            </div>
          </div>
          <div className="col inner">
            <div className="headCard">
              Our Technology at your Service
            </div>
            <div className="topP">
              <p>
                Our platform can integrate with the reservation and property management systems but can also be used as an external tool.
              </p>
            </div>
            <div
              className="bottomP">
              <p>
                Proprietary technology that improves your KPIs time and accuracy in event planning and sales processes.
              </p>
            </div>
          </div>
          <div className="col ">
            <div className="headCard">
              +40% Cost Efficient
            </div>
            <div className="topP">
              <p>
                Advanced automation allow our operations outperform any efficiency metric in the AV industry.
              </p>
            </div>
            <div
              className="bottomP">
              <p>
                We pass these savings on to our partners in the way they prefer through our 4 collaboration models.
              </p>
            </div>
          </div>






        </div>
      </section>
      <section className="contactComp">
        <div className="orderContact">
          <div className="upperBold">Contact us</div>
          <strong>Discover how we are reshaping M&E Corporate AV Landscape</strong>

          <div className="row">
            {bHours && <div className="col">
              <AiOutlinePhone />
              <p>Give us a call and talk with a partnership account manager at the moment</p>
              <a className='button btn-2 highLight ' href="tel:+13059744411" onClick={() => gtag.event({ action: 'contact_popup_assistance_call', label: 'leads', value: 15, category: 'orders' })}>(305) 974-4411</a>
            </div>}

            <div className="col">
              <AiOutlineClockCircle />
              <p>Request to be called at a time of your choice to go over our AV partnership models</p>
              <Button className="btn-2 highLight " onClick={() => dispatch(SHOW_POPUP({ key: 'quote', body: <QuotePopup call /> }))} >Schedule Call</Button>
            </div>
            <div className="col">
              <AiOutlineMail />
              <p>Tell us more about your case so we can offer you the partnertship model that adapts best to your needs</p>
              <Button className="btn-2 highLight " onClick={() => {

                dispatch(SHOW_POPUP({ key: 'quote', body: <QuotePopup /> }))
              }}  >Request Partnership Assesment</Button>
            </div>


          </div>
        </div>

      </section>
   <B2BIndex one={one} two={two} three={three} four={four} setModel={setModel} />




    </div>
    {model ==='one' && <B2BModelOne />}
    {model ==='two' && <B2BModelTwo />}
    {model ==='three' && <B2BModelThree />}
    {model ==='four' && <B2BModelFour />}
    <B2BTable one={true} two={true} three={true} four={true} />
    <section className='readyToSign'>
      <strong className='title upperBold'>Ready to  sign in?</strong>
      <p>Fill out the form and start getting partnership benefits</p>
      <div className="buttons">
        <Button className='btn-4 highLight ' onClick={() => showForm(true)}><AiOutlineForm />Start Application</Button>
      </div>
    </section>

    <PastEvents ui='v2' filter={['conference', 'corporate', 'fashion']} newsletterevents={newsletterevents} total_events={total_events} />
    <ClientReviews ui='v2' />
  </>

}

export default Partnerships
